var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuggestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_392_158943)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8333 19.9167C39.8333 30.8974 30.8974 39.8053 19.9167 39.8053C8.90788 39.8053 0 30.8974 0 19.9167C0 8.90788 8.90788 0 19.9167 0C30.8974 0 39.8333 8.90788 39.8333 19.9167Z",
    fill: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_392_158943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 38,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1175 23.2716C39.1175 33.4176 30.8903 41.6448 20.7443 41.6448C10.5983 41.6448 2.37109 33.4176 2.37109 23.2716C2.37109 13.1256 10.5983 4.89844 20.7443 4.89844C30.8903 4.89844 39.1175 13.1256 39.1175 23.2716Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_392_158943)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7144 30.0013L39.5744 29.8612C39.5744 29.8612 39.565 29.8519 39.5464 29.8332L39.7424 29.6651L33.9439 23.8666C33.8599 23.5585 33.6918 23.2503 33.4397 22.9982L33.4117 22.9702C34.7843 20.4771 34.6722 17.3958 33.0475 15.0148V13.25H31.3948C28.6496 11.1771 24.84 11.1771 22.1228 13.25H20.7222V14.6506C18.6213 17.3678 18.6213 21.2055 20.7222 23.9226V25.5753H22.4869C24.84 27.172 27.8653 27.3121 30.3304 25.9955L30.3864 26.0516C30.6385 26.3037 30.9466 26.4717 31.2548 26.5558L37.0533 32.3543L37.2213 32.1862C37.24 32.1862 37.2494 32.1862 37.2494 32.1862L37.3894 32.3263C37.9777 32.9426 38.9861 32.9426 39.5744 32.3263L39.7144 32.1862C40.3307 31.598 40.3307 30.6175 39.7144 30.0013Z",
    fill: "#C5C5C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5441 46.6673L9.8822 46.6953L9.82617 17.3386L32.516 17.3105L32.5441 46.6673Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.919 43.4183L8.22918 43.4743L8.20117 14.0895L30.863 14.0615L30.919 43.4183Z",
    fill: "#D3D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9855 45.3516L6.32361 45.3796L6.26758 16.0228L28.9574 15.9668L28.9855 45.3516Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4364 23.8931C26.4364 26.1061 24.6436 27.8989 22.4306 27.8989H13.3827C11.1697 27.8989 9.37695 26.1061 9.37695 23.8931C9.37695 21.6522 11.1697 19.8594 13.3827 19.8594H22.4306C24.6436 19.8594 26.4364 21.6522 26.4364 23.8931Z",
    fill: "#D3D3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2874 33.9503H10.1328V31.2051H25.2874V33.9503Z",
    fill: "#D3D3D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2874 39.0763H10.1328V36.3311H25.2874V39.0763Z",
    fill: "#D3D3D3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5783 26.3864C14.2786 25.1538 14.6428 23.5571 15.035 22.1845C14.6615 22.1845 14.288 22.1845 13.9145 22.1845C14.6428 24.3415 15.2871 26.5545 16.0714 28.6834C16.2675 29.1596 17.0798 29.2996 17.1919 28.6834C17.7521 25.518 18.4244 22.3806 19.0967 19.2433C18.7232 19.2433 18.3591 19.2433 18.0043 19.2433C18.7046 22.6327 18.9847 26.0782 19.769 29.4397C19.8811 29.8879 20.6374 30.056 20.8335 29.5798C21.7019 27.4789 22.5422 25.3499 23.2986 23.193C23.5507 22.5207 22.4582 22.2126 22.2061 22.9129C21.4497 24.9578 20.6934 27.0026 19.825 28.9915C20.1799 29.0475 20.5347 29.0942 20.8895 29.1316C20.0772 25.7701 19.825 22.3246 19.0967 18.9632C18.9847 18.4029 18.1163 18.4029 18.0043 18.9632C17.3039 22.0725 16.6316 25.2099 16.0714 28.3752C16.4449 28.3752 16.8184 28.3752 17.1919 28.3752C16.3795 26.2463 15.7353 24.0614 15.035 21.8764C14.8389 21.3442 14.0825 21.3162 13.9145 21.8764C13.5783 23.165 13.2422 24.6776 12.5699 25.8261C12.2057 26.4704 13.1862 27.0307 13.5783 26.3864Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_392_158943",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 11,
    width: 13,
    height: 14
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0781 24.2031H33.3867V11.8945H21.0781V24.2031Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_392_158943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7881 13.8947C34.1691 16.3037 34.1691 20.1974 31.7881 22.5785C29.3791 24.9875 25.4854 24.9875 23.0763 22.5785C20.6673 20.1974 20.6673 16.3037 23.0763 13.8947C25.4854 11.4856 29.3791 11.4856 31.7881 13.8947Z",
    fill: "#EAEAE9"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0523 28.6281C40.6685 29.2444 40.6685 30.2248 40.0523 30.8411L39.9122 30.9531C39.324 31.5694 38.3435 31.5694 37.7273 30.9531L37.5872 30.8411C36.9709 30.2248 36.9709 29.2444 37.5872 28.6281L37.7273 28.4881C38.3435 27.8998 39.324 27.8998 39.9122 28.4881L40.0523 28.6281Z",
    fill: "#C93831"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4595 12.5492C35.4288 15.5185 35.4288 20.3366 32.4595 23.3059C29.5183 26.2752 24.7002 26.2752 21.7309 23.3059C18.7616 20.3366 18.7616 15.5185 21.7309 12.5492C24.7002 9.57994 29.5183 9.57994 32.4595 12.5492ZM31.115 13.8938C28.902 11.6809 25.2884 11.6809 23.0755 13.8938C20.8625 16.1068 20.8625 19.7204 23.0755 21.9333C25.2884 24.1463 28.902 24.1463 31.115 21.9333C33.3279 19.7204 33.3279 16.1068 31.115 13.8938Z",
    fill: "#757575"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0791 28.2923L37.39 30.9815L31.1152 24.7067L33.8044 22.0176L40.0791 28.2923Z",
    fill: "#757575"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7759 21.6249C34.5883 22.4373 34.5883 23.7819 33.7759 24.5942L33.6919 24.6783C32.8795 25.4906 31.535 25.4906 30.7226 24.6783L30.6386 24.5942C29.8262 23.7819 29.8262 22.4373 30.6386 21.6249L30.7226 21.5409C31.535 20.7286 32.8795 20.7286 33.6919 21.5409L33.7759 21.6249Z",
    fill: "#6D7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_392_158943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestion);
export default __webpack_public_path__ + "static/media/suggestion.fea804f102593e13286d9055f18a0e79.svg";
export { ForwardRef as ReactComponent };